import axios from './axios'
import { Result } from '@/service/model'

interface Reauest {
  responseType: string
  get<T>(url: string, params?: unknown): Promise<Result<T>>
  post<T>(url: string, params?: unknown, responseType?: boolean, contentType?: string): Promise<Result<T>>
  upload<T>(url: string, params: unknown): Promise<Result<T>>
  download(url: string): void
}

const request: Reauest = {
  get(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, { params })
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err.data)
        })
    })
  },
  post(url, obj?: any, isArraybuffer?: boolean, contentType?: string) {
    const { switchApi, ...params } = obj || {}
    return new Promise((resolve, reject) => {
      axios
        .post(switchApi || url, contentType ? obj : JSON.stringify(params), {
          responseType: isArraybuffer ? 'arraybuffer' : 'json',
          headers: { 'Content-Type': contentType ? 'multipart/form-data' : 'application/json' }
        })
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err.data)
        })
    })
  },
  upload(url, file) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, file, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err.data)
        })
    })
  },
  download(url) {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    iframe.onload = function () {
      document.body.removeChild(iframe)
    }
    document.body.appendChild(iframe)
  },
  responseType: ''
}
export default request
